import './App.css'
import { useState } from 'react'
import GameBoardV2 from './components/v2/GameBoardV2'
import RulesModal from './components/RulesModal'
import SignInScreen from './components/SignInScreen'
import LobbyScreen from './components/LobbyScreen'
import HomefrontMakerV3 from './components/HomefrontMakerV3'
import BattleScreenPreview from './components/v2/BattleScreenPreview'
import UserBadge from './components/UserBadge'
import PrototypeApp from './components/prototype/PrototypeApp'
import { useAuthFromContext } from './AuthContext'
import { useGameContext } from './GameContext'
import { setSoundMuted } from './utils/soundManager'

const PREVIEW_MODE = new URLSearchParams(window.location.search).has('preview')
const MAKER_MODE = new URLSearchParams(window.location.search).has('maker')
// Read on each render: the prototype clears its own URL params (?invite).
const legacyMode = () => new URLSearchParams(window.location.search).has('legacy')

export default function App() {
  const { authStatus } = useAuthFromContext()
  const { lobbyStatus, leaveRoom, saveHomefront, homefront } = useGameContext()
  const [rulesOpen, setRulesOpen] = useState(false)
  const [soundOn, setSoundOn] = useState(true)   // audio defaults on

  const toggleSound = () => {
    setSoundOn(on => {
      const next = !on
      setSoundMuted(!next)
      return next
    })
  }

  // `?preview` — the battle screen on an archived war's Grids, no sign-in or
  // pairing needed (BattleScreenPreview).
  // `?maker` — the Hive maker on its own, no sign-in; LOCK HIVE just logs.
  if (MAKER_MODE) {
    return <HomefrontMakerV3 onSave={(hf) => console.log('lock grid:', hf)} initialHomefront={null} />
  }

  if (PREVIEW_MODE) {
    return (
      <main>
        <div className="centered">
          <BattleScreenPreview />
        </div>
      </main>
    )
  }

  if (authStatus === 'loading') {
    return <div className="auth-loading" />
  }

  if (authStatus === 'unauthenticated') {
    return <SignInScreen />
  }

  // Signed in: the progression prototype, unless `?legacy` asks for the old
  // lobby (room codes, the Hive maker, the client-run war).
  if (!legacyMode()) {
    return <PrototypeApp />
  }

  if (lobbyStatus === 'setup-homefront') {
    return <HomefrontMakerV3 onSave={saveHomefront} initialHomefront={homefront ?? null} />
  }

  if (lobbyStatus === 'in-game') {
    return (
      <main>
        <RulesModal isVisible={rulesOpen} onClose={() => setRulesOpen(false)} />
        <div className="centered">
          <GameBoardV2 />
        </div>
        <div className="aux-section">
          <div className="game-and-user-div">
            <UserBadge />
          </div>
          <div className="new-game-area">
            <div className="new-game-row">
              <button className="rules-btn" onClick={() => setRulesOpen(true)}>
                <span className="new-game-btn__main">Rules</span>
              </button>
              <button
                className="audio-btn"
                onClick={toggleSound}
                aria-pressed={soundOn}
                aria-label={soundOn ? 'Mute sound' : 'Unmute sound'}
                title={soundOn ? 'Sound on' : 'Sound off'}
              >
                {soundOn ? (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M11 5 6 9H2v6h4l5 4z" />
                    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
                    <path d="M18.5 5.5a9 9 0 0 1 0 13" />
                  </svg>
                ) : (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M11 5 6 9H2v6h4l5 4z" />
                    <line x1="22" y1="9" x2="16" y2="15" />
                    <line x1="16" y1="9" x2="22" y2="15" />
                  </svg>
                )}
              </button>
              <button className="new-game-btn" onClick={leaveRoom}>
                <span className="new-game-btn__main">Exit Match</span>
              </button>
            </div>
          </div>
        </div>
      </main>
    )
  }

  return <LobbyScreen />
}
